import { JavaAPIClient } from "../lib/apiHelper";

const { get, post, put, remove } = new JavaAPIClient();

export default {
    /**
     * 근무유형 생성
     * @param {*} worktype
     */
    add: (worktype) => post('/worktype', worktype),
    /**
     * 근무유형 수정
     * @param {*} worktype
     */
    modify: (worktype) => put('/worktype', worktype),
    /**
     * 근무유형 삭제
     * @param {*} abntdWorkTypCd
     */
    delete: (worktype) => remove('/worktype', worktype),
    /**
     * 근무유형 리스트 조회
     * @param {*} companyId
     */
    list: (companyId, workSystemName) => get('/worktype?companyId='+ companyId+ (workSystemName ? '&workSystemName=' + workSystemName :'')),
    /**
     * 근무유형 상태변경
     * @param {*} worktype
     */
    updateStatus: (worktype) => put('/worktype/updateStatus', worktype),
   
    getFlexibleWorkSummaryData: (payload) => post('/group/flexible-work-summary', payload),

};